import { gql } from 'apollo-boost';
export const GET_FOLDER_REFERENCES = gql`
    query getFolderReferences { getFolderReferences { id folderId title token available isFavorite } }
`;
